import { loadRemoteModule } from '@angular-architects/module-federation';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import config from '../../../assets/config.json';

@Component({
  selector: 'app-bob-error',
  standalone: true,
  imports: [],
  templateUrl: './bob-error.component.html',
  styleUrl: './bob-error.component.scss',
})
export class BobErrorComponent {
  @ViewChild('ErrorComponent', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;
  constructor() {}

  async ngOnInit() {
    const { ErrorComponent } = await loadRemoteModule({
      type: 'module',
      remoteEntry: config.bobRemoteURL,
      exposedModule: './ErrorComponent',
    });
    const componentFactory: any = this.container.createComponent(ErrorComponent);
    this.container.insert(componentFactory.hostView);
  }
}
